export default __webpack_public_path__ + "static/media/1.2561b2a1.jpg";